import { Response } from '@marketplace-web/shared/api-client'

import { CountryBoundsResponse } from 'types/api/response/country-bounds-response'

import { transformCountryBoundsDto } from 'data/transformers/country-bounds'

export const transformCountryBounds = ({ country_bounds }: Response<CountryBoundsResponse>) => {
  if (!country_bounds) return null

  return transformCountryBoundsDto(country_bounds)
}
